import React, { useState, useEffect } from 'react';
import Filters from '../components/reviews/Filters';
import ReviewList from '../components/reviews/ReviewList';

// Import the mock data
// In a real app, you would fetch this from an API
import { livpureMockData } from '../data';

const Reviews = () => {
  const today = new Date();
  const thrityDaysAgo = new Date();
  thrityDaysAgo.setDate(today.getDate() - 30);
  
  const [reviews, setReviews] = useState([]);
  const [filteredReviews, setFilteredReviews] = useState([]);
  const [filters, setFilters] = useState({
    source: '',
    region: '',
    city: '', 
    startDate: thrityDaysAgo,
    endDate: today,
    replyStatus: '',
    sentiment: ''
  });
  
  // Load reviews on component mount
  useEffect(() => {
    try {
      // In a real app, you would fetch this from an API
      const data = livpureMockData.reviews;
      setReviews(data);
      setFilteredReviews(data);
    } catch (error) {
      console.error('Error loading reviews data:', error);
      // Handle error appropriately
    }
  }, []);
  
  // Apply filters when they change
  useEffect(() => {
    applyFilters();
  }, [filters, reviews]);
  
  const applyFilters = () => {
    let result = [...reviews];
    
    // Filter by source/channel
    if (filters.source) {
      result = result.filter(review => review.source === filters.source);
    }
    
    // Filter by region
    if (filters.region) {
      result = result.filter(review => review.region === filters.region);
    }
    
    // Filter by city
    if (filters.city) {
      result = result.filter(review => review.city === filters.city);
    }
    
    // Filter by date range
    if (filters.startDate) {
      result = result.filter(review => new Date(review.date) >= filters.startDate);
    }
    
    if (filters.endDate) {
      // Add one day to include the end date fully
      const endDatePlus = new Date(filters.endDate);
      endDatePlus.setDate(endDatePlus.getDate() + 1);
      result = result.filter(review => new Date(review.date) <= endDatePlus);
    }
    
    // Filter by reply status
    if (filters.replyStatus) {
      result = result.filter(review => review.replyStatus === filters.replyStatus);
    }
    
    // Filter by sentiment
    if (filters.sentiment) {
      result = result.filter(review => review.sentiment === filters.sentiment);
    }
    
    // Sort by date (most recent first)
    result.sort((a, b) => new Date(b.date) - new Date(a.date));
    
    setFilteredReviews(result);
  };
  
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Customer Reviews</h1>
        <p className="text-sm text-gray-600">Monitor and analyze customer feedback across all channels</p>
      </div>
      
      <Filters 
        filters={filters} 
        setFilters={setFilters} 
        regions={livpureMockData.regions} 
      />
      
      <ReviewList reviews={filteredReviews} />
    </div>
  );
};

export default Reviews;